import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import grievanceServices from '../grievanceServices';
import { useAppData } from '../../../../../../context/AppDataContext';
import GrievanceRemarkForm from '../components/GrievanceRemarkForm';
import GrievanceRemarkList from '../components/GrievanceRemarkList';
import GrievanceStatusUpdate from '../components/GrievanceStatusUpdate';
import CRMLayout from '../../../../../../layout/components/CRMLayout';
import GrievanceForm from '../components/GrievanceForm';
import ConfirmDialog from '../../../../../../components/ConfirmDialog';
import { useAlert } from '../../../../../../context/AlertContext';
import { Refresh } from '@mui/icons-material';


const LabelValue = ({label,value}) =>{
    return(
        <div className='row'>
            <div className='col-md-6 fw-bold'>{label}</div>
            <div className='col-md-6 fw-bold'>{value}</div>
        </div>
    )
}


function GrievanceDetailsPage() {
    const {id} = useParams();
    const {getMasterLabel} = useAppData();
    const [grievanceDetails,setGrievanceDetails] = useState(null);
    const {AppAlert} = useAlert();
    const navigate = useNavigate();


    const [refreshKey, setRefreshKey] = useState(0);

    const callBack = () => {
        // Incrementing this will change the prop passed to the list
        setRefreshKey(prev => prev + 1);
    };

    const getGrievanceDetails = () =>{
        grievanceServices.getById(id).then(res=>{
            setGrievanceDetails(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }

    useEffect(()=>{
        getGrievanceDetails();
    },[id])


    const remove = (id) =>{
        grievanceServices.remove(id).then(res=>{
            navigate("/grievance/dashboard");
            AppAlert("Archived Successfully");
        }).catch(error=>{
            AppAlert(error.msg,"error")
        }).finally(()=>{

        })
    }

    const restore = (id) =>{
        grievanceServices.restore(id).then(res=>{
            navigate("/grievance/dashboard");
            AppAlert("Restore Successfully");
        }).catch(error=>{
            AppAlert(error.msg,"error")
        }).finally(()=>{

        })
    }

    return (
        grievanceDetails &&
        <CRMLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-4'>
                        <div className='card'>
                            <div className='card-header'>
                                <span className='float-end'>
                                    <GrievanceForm  callBack={getGrievanceDetails} data={grievanceDetails} />
                                    {grievanceDetails.deleted_at == null ?
                                        <ConfirmDialog id={grievanceDetails.id} confirm={remove}>Are You Sure you want to remove this complaint</ConfirmDialog>
                                        :
                                        <button className='btn btn-danger' onClick={()=>restore(grievanceDetails.id)}><Refresh/></button>
                                    }
                                    
                                </span>
                            </div>
                            <div className='card-body'>
                                <LabelValue label="Customer Name" value={grievanceDetails.customerName} />
                                <LabelValue label="Customer Phone" value={grievanceDetails.customerPhone} />
                                <LabelValue label="Grievance Type" value={getMasterLabel('grievance-type',grievanceDetails.grievanceType)} />
                                <LabelValue label="UID" value={grievanceDetails.uid} />
                                <div className='row mt-3'>
                                    <hr/>
                                    <div className='col-md-12 fw-bold'>Complain Details</div>
                                    <div className='col-md-12'>{grievanceDetails.textMessage}</div>
                                </div>
                            </div>
                            <div className='card-footer'>
                                
                            </div>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <GrievanceRemarkForm grievanceId={id} callBack={callBack} />
                        <GrievanceRemarkList grievanceId={id} refreshTrigger={refreshKey} />
                    </div>
                    <div className='col-md-4'>
                        <GrievanceStatusUpdate grievanceDetails={grievanceDetails} callBack={getGrievanceDetails} />
                    </div>
                </div>
            </div>
        </CRMLayout>
    )
}

export default GrievanceDetailsPage